export default __webpack_public_path__ + "static/freshMS@2x-2e1d4674f616d0d6e0bfed3536984f69.jpg";